const getDefaultState = () => {
    return {
        articles: [],
        showArticles: false
    }
}
const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations: {
        setArticles(state, payload) {
            state.articles.push(payload)
        },
        delArticles(state) {
            state.articles = []
        },
        setShowArticles(state) {
            if (state.articles.length) {
                state.showArticles = true
            } else {
                state.showArticles = false
            }
        }
    },
    getters: {
        getArticles(state) {
            return state.articles
        },
        getShowArticles(state) {
            return state.showArticles
        }
    }
}
